export default function Error() {
  return (
    <div
      style={{
        display: "flex",
        height: "48vh",
        alignItems: "center",
        justifyContent: "center",
      }}
    >
      <h1>Server Error</h1>
    </div>
  );
}
